import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import MaterialTable from 'material-table';
import { Container } from '@material-ui/core';
import React, { useEffect, useState, useRef } from 'react';
import Brightness1Icon from '@material-ui/icons/Brightness1';

import api from '../../../../services/api.js';

import Edit from './Components/Edit.js'

export default function MyTable(props) {
    const tableRef = useRef();
    const snack = useRef()
    const { enqueueSnackbar } = useSnackbar();
    snack.current = enqueueSnackbar

    const [funcoes, setFuncoes] = useState([]);

    const state = {
        columns: [
            {
                title: "Opções", field: "opcoes", cellStyle: { width: '10%', textAlign: "center", },
                render: (rowData) => {
                    return (
                        <Edit setData={props.setData} setOpen={props.setOpen} data={rowData} />
                    )
                }
            },
            {
                title: "Cor",
                cellStyle: { width: '10%', maxWidth: '10%' },
                headerStyle: { width: '10%', maxWidth: '10%' },
                render: (rowData) => {
                    return (
                        <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                            <Brightness1Icon fontSize="small" style={{ marginRight: "2%", color: rowData.setcolor }} />
                            {rowData.cor}
                        </div>
                    )
                }
            },
            { title: "Estado", field: "estado", },
            { title: "Probabilidade de Acidente", field: "acidente", },
            {
                title: "Grupos Notificados", render: (rowData) => {
                    return (
                        <>
                            {rowData.grupo_notificacoes.map(txt => <p>{txt}</p>)}
                        </>
                    )
                }
            },
        ],
    };

    useEffect(() => {
        async function fetchData() {
            api.get(`/nivelresp`)
                .then((res) => {
                    let niveis_resp = []
                    for (let n_resp of res.data) {
                        let lista_nome_funcao = []
                        for (let funcao of n_resp.funcoes) {
                            lista_nome_funcao.push(funcao.funcao)
                        }
                        let x = n_resp.cor
                        let aux = {
                            _id: n_resp._id,
                            cor: n_resp.cor,
                            setcolor: x === 'Verde' ? '#adcd98' : x === 'Amarelo' ? '#f7d869' : x === 'Azul' ? '#99ccff' : x === 'Laranja' ? '#e68a00' : x === 'Vermelho' ? '#dd0808' : '#8c8c8c',
                            estado: n_resp.estado,
                            evento: n_resp.evento,
                            funcoes: n_resp.funcoes,
                            anomalia: n_resp.anomalia,
                            acidente: n_resp.acidente,
                            criado_em: n_resp.criado_em,
                            editado_em: n_resp.editado_em,
                            criado_por: n_resp.criado_por,
                            editado_por: n_resp.editado_por,
                            grupo_notificacoes: lista_nome_funcao,
                        }
                        niveis_resp.push(aux)
                    }
                    setFuncoes(niveis_resp)
                })
                .catch((error) => {
                    console.log(error);
                    snack.current("Falha ao buscar Níveis de Resposta", { variant: 'error' })
                });
        }
        fetchData();
    }, [props.reload]);

    return (
        <Container maxWidth={false} spacing={2}>
            <MaterialTable
                tableRef={tableRef}
                title="Nível de Resposta"
                columns={state.columns}
                data={funcoes}
                options={{
                    search: true,
                    pageSize: 10,
                    exportButton: false,
                    emptyRowsWhenPaging: false,
                    pageSizeOptions: [1, 5, 10, 20, funcoes.length],
                    padding: "dense",
                    headerStyle: {
                        textAlign: "center",
                        color: "#b31b1b",
                    },
                    cellStyle: {
                        textAlign: "center",
                    },
                }}

                localization={{
                    body: {
                        emptyDataSourceMessage: "",
                        addTooltip: "adicionar novo",
                        deleteTooltip: "excluir",
                        editRow: { deleteText: "Deseja excluir?" },
                    },

                    header: {
                        actions: "Opções",
                    },

                    toolbar: {
                        searchTooltip: "Pesquisar",
                        searchPlaceholder: "Pesquisar",
                        exportTitle: "exportar",
                        nRowsSelected: "{0} Usuários(s) selecionados",
                    },
                    pagination: {
                        labelRowsSelect: "",
                        labelDisplayedRows: "{count} de {from}-{to}",
                        firstTooltip: "Primeira página",
                        previousTooltip: "Página anterior",
                        nextTooltip: "Próxima página",
                        lastTooltip: "Última página",
                    },
                }}
            />
        </Container >
    );
}

MyTable.propTypes = {
    reload: PropTypes.bool,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
    setReload: PropTypes.func,
    setAffiliates: PropTypes.func,
};
